export default __webpack_public_path__ + "4b85bd216618cb510949cae95f88c1fa.svg";